import { render, staticRenderFns } from "./SubHome.vue?vue&type=template&id=5bfef0db&scoped=true&"
import script from "./SubHome.vue?vue&type=script&lang=js&"
export * from "./SubHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfef0db",
  null
  
)

export default component.exports